module.exports = __webpack_public_path__ + "img/blogIcon.15a8d9d4.svg";